module.exports = __webpack_public_path__ + "f0e80114f7bc00c51c2057b9a43420f3.png";